import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgDhl({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M3 3h18a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1z" fill="#FECC00" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.448 11.677a26.89 26.89 0 00-.155.213c-.06.084-.121.169-.167.23-.045.062-.127.173.144.173h1.424l.422-.573c.261-.356.022-1.095-.913-1.095H5.517l-.639.868h3.483c.176 0 .173.067.087.184zm-1.046.83c-.27 0-.189-.111-.144-.172l.18-.244.145-.198c.086-.117.089-.184-.087-.184H5.903L4.62 13.453h3.13c1.033 0 1.608-.703 1.786-.946H7.402zm3.872.946H9.438l.696-.946h1.836l-.696.946zm2.9-2.828l-.703.957h-.82l.704-.957H11.52l-1.228 1.668h4.49l1.228-1.668h-1.835zm-.245 2.828h-1.836l.697-.946h1.835l-.697.946zM2 12.88v.201h2.557l.148-.2H2zm0-.373h2.98l-.149.2H2v-.2zm0 .946h2.283l.147-.2H2v.2zm20-.372h-2.694l.148-.2H22v.2zm-2.968.372H22v-.2h-2.821l-.147.2zm.548-.745l.148-.2H22v.2h-2.42zm-2.256-.415l1.228-1.668h-1.944l-1.229 1.668h1.945zm-2.301.486l.199-.272h4.17l-.696.946h-2.948c-.752 0-.956-.363-.725-.674z"
        fill="#D50029"
      />
    </svg>
  )
}

export default SvgDhl
